import { useQuery } from "react-query";
import { AxiosResponse } from "axios";

import { IGetCustomersQueryParams, IGetCustomersRes } from "types/customer";
import customersService from "api/customersService";

const useGetCustomers = (query: IGetCustomersQueryParams, enabled?: boolean) => {
  return useQuery(["customers", { ...query }], async () => {
    try {
      const res: AxiosResponse<IGetCustomersRes> = await customersService.getCustomers(query)

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false, refetchOnMount: false })
}

export default useGetCustomers